import { render, staticRenderFns } from "./LittleGate.vue?vue&type=template&id=44d3b3fe&scoped=true"
import script from "./LittleGate.vue?vue&type=script&lang=ts"
export * from "./LittleGate.vue?vue&type=script&lang=ts"
import style0 from "./LittleGate.vue?vue&type=style&index=0&id=44d3b3fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d3b3fe",
  null
  
)

export default component.exports